export class ContextAnalyzer {
  constructor() {
    this.contextStack = [];
    this.topicMap = new Map();
  }

  // Analyze user input for topic and intent
  analyzeInput(input) {
    const topics = {
      tickets: ['ticket', 'price', 'cost', 'buy', 'refund'],
      camping: ['camp', 'tent', 'accommodation', 'sleep'],
      safety: ['safe', 'security', 'emergency', 'help', 'medical'],
      facilities: ['toilet', 'shower', 'water', 'charging'],
      transport: ['car', 'parking', 'drive', 'bus', 'shuttle'],
      // Add more topics as needed
    };

    const foundTopics = new Set();
    for (const [topic, keywords] of Object.entries(topics)) {
      if (keywords.some(keyword => input.toLowerCase().includes(keyword))) {
        foundTopics.add(topic);
      }
    }

    return {
      topics: Array.from(foundTopics),
      isQuestion: this.isQuestion(input),
      sentiment: this.analyzeSentiment(input)
    };
  }

  isQuestion(input) {
    const questionIndicators = [
      '?',
      'what', 'when', 'where', 'who', 'how', 'why',
      'can', 'could', 'will', 'would', 'should',
      'is', 'are', 'do', 'does'
    ];
    return questionIndicators.some(indicator => 
      input.toLowerCase().startsWith(indicator) || input.includes('?')
    );
  }

  analyzeSentiment(input) {
    const positiveWords = ['good', 'great', 'awesome', 'love', 'nice', 'thanks', 'please'];
    const negativeWords = ['bad', 'terrible', 'hate', 'awful', 'wrong', 'angry'];
    
    const inputLower = input.toLowerCase();
    const positiveCount = positiveWords.filter(word => inputLower.includes(word)).length;
    const negativeCount = negativeWords.filter(word => inputLower.includes(word)).length;
    
    return {
      isPositive: positiveCount > negativeCount,
      isNegative: negativeCount > positiveCount,
      isNeutral: positiveCount === negativeCount
    };
  }

  updateContext(input, response) {
    this.contextStack.push({
      input,
      response,
      timestamp: Date.now(),
      analysis: this.analyzeInput(input)
    });

    // Keep only last 5 interactions for context
    if (this.contextStack.length > 5) {
      this.contextStack.shift();
    }
  }

  getRelevantContext() {
    return this.contextStack;
  }
}
